import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=0d2e4b63"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2e4b63')) {
      api.createRecord('0d2e4b63', component.options)
    } else {
      api.reload('0d2e4b63', component.options)
    }
    module.hot.accept("./snackbar.vue?vue&type=template&id=0d2e4b63", function () {
      api.rerender('0d2e4b63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/alert/snackbar.vue"
export default component.exports